import React from "react";
import PropTypes from "prop-types";
import Toggle from "react-toggle";

import HelpText from "components/HelpText";

import "./index.css";
import { cn } from "utils";

const CustomToggle = ({
  checked,
  valueKey,
  leftLabel,
  rightLabel,
  helpText,
  onChange,
  toolTipClassName,
  helpIconType,
  helpIconClassName,
  helpIconSize,
  labelClassName,
  toggleClassName,
  size,
  className = "",
}) => {
  const handleChange = ({ target: { checked } }) => {
    onChange(checked, valueKey);
  };

  return (
    <div className={cn("flex gap-2", className)}>
      {leftLabel && (
        <p className={cn("mr-2 font-normal text-sm", labelClassName)}>
          {leftLabel}
        </p>
      )}

      <Toggle
        checked={checked}
        onChange={handleChange}
        icons={false}
        className={cn(
          "customToggle",
          {
            "customToggle--medium": size === "medium",
            "customToggle--large": size === "large",
          },
          toggleClassName
        )}
      />

      {rightLabel && (
        <p className={cn("font-normal text-sm", labelClassName)}>
          {rightLabel}
        </p>
      )}

      {helpText && (
        <HelpText
          text={helpText}
          iconType={helpIconType}
          iconTextClassName={helpIconClassName}
          iconSize={helpIconSize}
          toolTipClassName={toolTipClassName}
        />
      )}
    </div>
  );
};

CustomToggle.propTypes = {
  checked: PropTypes.bool,
  valueKey: PropTypes.string,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  helpText: PropTypes.string,
  onChange: PropTypes.func,
  helpIconType: PropTypes.string,
  helpIconClassName: PropTypes.string,
  helpIconSize: PropTypes.number,
  labelClassName: PropTypes.string,
  toggleClassName: PropTypes.string,
  size: PropTypes.oneOf(["default", "medium", "large"]),
};

CustomToggle.defaultProps = {
  checked: true,
  valueKey: "",
  leftLabel: "",
  rightLabel: "",
  helpText: "",
  onChange: () => {},
  helpIconType: "svg",
  helpIconClassName: "",
  helpIconSize: 20,
  labelClassName: "",
  toggleClassName: "",
  size: "default",
};

export default CustomToggle;
